import { render } from "./StipendCourseView.vue?vue&type=template&id=1a98c920&ts=true"
import script from "./StipendCourseView.vue?vue&type=script&lang=ts"
export * from "./StipendCourseView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__